import { businessInfo } from '../data/mock';

/**
 * Envoltura sobre PostHog, que se inicializa en public/index.html.
 * Si el script no cargó -bloqueador de anuncios, red caída, prerender-
 * el evento se pierde en silencio: la analítica nunca debe costar una venta.
 */
export const track = (event, properties = {}) => {
  try {
    window.posthog?.capture(event, properties);
  } catch (e) {
    // noop
  }
};

/**
 * Único punto de salida hacia WhatsApp. Centralizarlo garantiza que
 * ningún CTA -ni los que se agreguen después- se quede sin medir.
 */
export const openWhatsApp = (location, message) => {
  track('whatsapp_clicked', { location, has_message: Boolean(message) });
  const url = message
    ? `${businessInfo.whatsapp}?text=${encodeURIComponent(message)}`
    : businessInfo.whatsapp;
  window.open(url, '_blank');
};

/** Handler listo para onClick en enlaces tel: y mailto:. */
export const trackPhone = (location) => () => track('phone_clicked', { location });
export const trackEmail = (location) => () => track('email_clicked', { location });
